function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import {
    Slider,
    Picker
} from './components/components';
var VideoColor = function () {
    function VideoColor(player) {
        var _this = this;
        _classCallCheck(this, VideoColor);
        this.player = player;
        this.video = player.video;
        this.filter = {
            brightness: 1,
            saturate: 1,
            contrast: 1
        };
        this.initBrightness();
        this.initSaturate();
        this.initContrast();
        this.player.template.video_color_mask.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        this.player.template.video_color_close.addEventListener('click', function () {
            _this.hide();
        });
        this.player.template.video_color_reset.addEventListener('click', function (e) {
            _this.reset();
        });
        this.videoFilterPicker = new Picker(this.player.template.video_filter_picker, 'none', {
            pick: function pick(value) {
                var _this$filter = _this.filter, saturate = _this$filter.saturate, contrast = _this$filter.contrast, brightness = _this$filter.brightness;
                _this.player.video.style.filter = value || 'brightness('.concat(brightness, ') contrast(').concat(contrast, ') saturate(').concat(saturate, ')');
            }
        });
    }
    _createClass(VideoColor, [
        {
            key: 'initBrightness',
            value: function initBrightness() {
                var _this2 = this;
                this.brightnessSlider = new Slider(this.player.template.video_brightness_slider, 0, 250, 1, this.filter.brightness * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        var _this2$filter = _this2.filter, saturate = _this2$filter.saturate, contrast = _this2$filter.contrast;
                        _this2.filter.brightness = value / 100;
                        _this2.player.template.video_brightness_value.innerText = value + '%';
                        _this2.player.video.style.filter = 'brightness('.concat(value / 100, ') contrast(').concat(contrast, ') saturate(').concat(saturate, ')');
                    },
                    end: function end() {
                    }
                });
            }
        },
        {
            key: 'initSaturate',
            value: function initSaturate() {
                var _this3 = this;
                this.saturateSlider = new Slider(this.player.template.video_saturate_slider, 0, 250, 1, this.filter.saturate * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        var _this3$filter = _this3.filter, brightness = _this3$filter.brightness, contrast = _this3$filter.contrast;
                        _this3.filter.saturate = value / 100;
                        _this3.player.template.video_saturate_value.innerText = value + '%';
                        _this3.player.video.style.filter = 'brightness('.concat(brightness, ') contrast(').concat(contrast, ') saturate(').concat(value / 100, ')');
                    },
                    end: function end() {
                    }
                });
            }
        },
        {
            key: 'initContrast',
            value: function initContrast() {
                var _this4 = this;
                this.contrastSlider = new Slider(this.player.template.video_contrast_slider, 0, 250, 1, this.filter.contrast * 100, {
                    start: function start() {
                    },
                    update: function update(value, flag) {
                    },
                    change: function change(value) {
                        var _this4$filter = _this4.filter, brightness = _this4$filter.brightness, saturate = _this4$filter.saturate;
                        _this4.filter.contrast = value / 100;
                        _this4.player.template.video_contrast_value.innerText = value + '%';
                        _this4.player.video.style.filter = 'brightness('.concat(brightness, ') contrast(').concat(value / 100, ') saturate(').concat(saturate, ')');
                    },
                    end: function end() {
                    }
                });
            }
        },
        {
            key: 'reset',
            value: function reset() {
                this.saturateSlider.update(100);
                this.brightnessSlider.update(100);
                this.contrastSlider.update(100);
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.template.video_color_mask.classList.add('show');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.template.video_color_mask.classList.remove('show');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.player.template.video_color_mask.classList.contains('show'))
                    this.hide();
                else
                    this.show();
            }
        }
    ]);
    return VideoColor;
}();
export {
    VideoColor as default
};